import { List, Stack, Typography } from "@mui/material";
import { CSection } from "./cr.ui.page";
import { useCrusade } from "./crusade";
import { useOrder } from "./order";
import { GREY } from "../style/theme";
import { CMatch, CPlayer } from "./cr.ui.crusade";
import { UEditableTextField } from "../common/ui.editable";


export function VanillaListPlayers() {
    const order = useOrder()
    const crusade = useCrusade()

    const players = crusade.players
        .filter(p => Boolean(p.codex))
        .sort((p1, p2) => p2.wins - p1.wins || p2.cp - p1.cp);

    return <CSection>
        <Stack>
            <Typography sx={{ color: GREY[800], fontWeight: 500, }}>Giocatori</Typography>

            <List>
                {players.map(p => <CPlayer key={p.id} player={p} />
                )}

            </List>

        </Stack>
    </CSection>
}

export function VanillaListPlayedMatches(props) {
    const { matches } = props;
    return <>

        {matches.map(m => <CMatch key={m.id} match={m} />
        )}
    </>
}

export function VanillaPlayerTitle() {
    const order = useOrder()

    return <>
        <UEditableTextField
            restCommit="player/order/edit/name"
            onComplete={order.reload}
            variant="h5"
            defValue={'Crociata di ' + order.player.name}
            value={order.name}

        />
        <UEditableTextField
            restCommit="player/order/edit/description"
            onComplete={order.reload}
            sx={{ fontSize: 12, color: GREY[900], whiteSpace: 'pre-wrap' }}
            defValue={'Racconta la storia del tuo esercito, cosa lo ha condotto fino a questo luogo impuro!\n\rQuali pericoli, insidie ed eresie ne hanno ostacolato o spianato la strada, fino a raggiungere i fasti di oggi?'}
            value={order.description}
            multiline
        />
    </>
}

export function vanillaAdminRewards() {
    return [
        {
            enabled: false,
            type: 'limit.increase',
            name: 'Aumento Limite',
            params: ['200']
        },
        {
            enabled: false,
            type: 'rp.increase',
            name: 'Aumento PR',
            params: ['1']
        },
        {
            enabled: false,
            type: 'marked.increase',
            name: 'Destinato alla Grandezza aggiuntivo',
            params: ['1']
        },
        {
            enabled: false,
            type: 'honours.increase',
            name: 'Onore aggiuntivo',
            params: ['1']
        },
    ]
}